import React from 'react'
import Sample from '../Components/Samples/Sample'
import { Box, Grid, Typography } from '@mui/material'
import FullHeight from 'react-full-height'

import "@fontsource/mukta"
import "@fontsource/archivo"

const Samples = () => {
    const samples = [
        {
            image:"canary.png",
            title:"Canary",
            paragraph:"The website was created to provide a platform for students who could not get access to resources at school due to Covid-19 to have a platform in which they could not only access those resources but also connect to their peers and play fun games!",
            link:"https://africanary.firebaseapp.com/"
        },
        {
            image:"nyerihigh.png",
            title:"School's Website",
            paragraph:"This was a website for a school that was designed to help better reach out to parents and also to help them update the old website design into a newer and more responsive one.",
            link:"https://drive.google.com/drive/folders/1S0hF9_Q5Fwh_yEv-xBhMGLYdBAfR2roh"
        },
        {
            image:"katanasounds.png",
            title:"Katana Sounds Record Label",
            paragraph:"This is a basic landing page for the Katana Sounds Recocord Label",
            link:"https://katanasounds-ke.web.app/"
        }
    ]
  return (
    <div>
        <FullHeight>
            <Box sx={{mt:10}}>
                <Box sx={{background:"white",p:4}}>
                    <Typography variant="h4" style={{fontFamily:"Archivo"}}>Samples Policy</Typography>
                    <Typography variant="p" style={{fontFamily:"Mukta"}}>We take customer privacy very seriously and therefore we can only show content as authorized by the owners, enjoy!</Typography>
                </Box>
                <Grid container>
                    
                        {samples.map((sample)=>{
                            return(
                          
                                    <Grid item xs={6} sx={{display:{xs:"none",md:"block"}}}>
                                        <Sample sample={sample}/>
                                    </Grid>
                               
                            )   
                        })}
                        
                        {samples.map((sample)=>{
                            return(
                          
                                <Grid item xs={12} sx={{display:{xs:"block",md:"none"}}}>
                                <Sample sample={sample}/>
                            </Grid>
                               
                            )   
                        })}
                        
                  
                    
                </Grid>
            </Box>
        </FullHeight>
    </div>
  )
}

export default Samples